import React, { useCallback } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Badge from '@material-ui/core/Badge'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import FormControl from '@material-ui/core/FormControl'
import RadioGroup from '@material-ui/core/RadioGroup'
import Radio from '@material-ui/core/Radio'
import Checkbox from '@material-ui/core/Checkbox'
import Calendar from '../book/Calendar'
import SlotTheme from '../book/slotTheme'
import AdminCalendarKey from './CalendarKey'

const useStyles = makeStyles(theme => {
  const slotTheme = SlotTheme(theme)
  return {
    root: {
      marginBottom: theme.spacing(4),
    },
    calendarContainer: {

    },
    condensedContainer: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
      marginBottom: theme.spacing(1),
    },
    searchContainer: {
      marginTop: theme.spacing(3),
      width: '100%',
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
    },
    searchBox: {
      width: '400px',
    },
  }
})

const AdminCalendar = ({
  children,
  calendar,
  onClickSlot,
  onEditDay,
}) => {

  const classes = useStyles()

  const wrapTitle = useCallback((children, slot) => {
    if(!children) return null
    if(Object.keys(slot._overriddenValues).length <= 0) return children
    return (
      <Badge
        color="secondary"
        variant="dot"
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        { children }
      </Badge>      
    )
  })

  return (
    <div className={ classes.root }>
      {
        children
      }
      <AdminCalendarKey />
      <div className={ classes.calendarContainer }>
        <Calendar
          admin
          calendar={ calendar }
          wrapTitle={ wrapTitle }
          onClickSlot={ onClickSlot }
          onEditDay={ onEditDay }
        >
          <div className={ classes.condensedContainer }>
            {
              calendar.calendarConfig.condensed && (
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={ calendar.condensed }
                      onChange={ (e) => calendar.setCondensed(e.target.checked) }
                    />
                  }
                  label="Condensed"
                />
              )
            }
            <FormControl component="fieldset">
              <RadioGroup row value={ calendar.slotFilter } onChange={ (e) => calendar.setSlotFilter(e.target.value) }>
                <FormControlLabel value="all" control={<Radio />} label="All" />
                <FormControlLabel value="canBook" control={<Radio />} label="Available" />
                <FormControlLabel value="booked" control={<Radio />} label="Booked" />
                <FormControlLabel value="adminOnly" control={<Radio />} label="Admin Only" />
                <FormControlLabel value="blocked" control={<Radio />} label="Blocked" />
              </RadioGroup>
            </FormControl>
          </div>
        </Calendar>
      </div>
    </div>
    
  )
}

export default AdminCalendar